<template>
    <section id="buy">
        <div class="py-5"></div>
        <v-container class="text-justify">
            <h2 class="display-2 font-weight-bold py-8 text-center">BUY TRAVERSE</h2>
            <v-responsive
                class="mx-auto px-2 mt-5"
                max-width="900"
            >
                <v-row justify="space-around" align="center">
                    <v-btn
                        v-for="buyOption in buyOptions"
                        :key="buyOption.key"
                        :href="buyOption.href"
                        :width="buyOption.width"
                        target="_blank"
                        text
                        color="white"
                        class="my-4"
                        style="margin: 5px 20px;"
                    >
                        <v-img
                            :src="buyOption.src"
                            :style="{
                                width: buyOption.width,
                                height: buyOption.height
                            }"
                            contain
                        ></v-img>
                    </v-btn>
                </v-row>
            </v-responsive>
        </v-container>
        <div class="py-5"></div>
      </section>
</template>

<script>
    export default {
        name: 'Buy',
        data () {
            return {
                buyOptions: [
                    {
                        key: 'amazon',
                        href: 'https://www.amazon.com/Educational-Insights-Traverse-20Th-Anniversary/dp/B000NPKYO4',
                        src: require('../assets/amazon-logo.svg'),
                        width: '100px',
                        height: '30px'
                    },
                    {
                        key: 'ebay',
                        href: 'https://www.ebay.com/sch/i.html?_nkw=traverse+board+game',
                        src: require('../assets/ebay-logo.svg'),
                        width: '100px',
                        height: '40px'
                    },
                    {
                        key: 'geek-market',
                        href: 'https://boardgamegeek.com/geekmarket/browse?objecttype=thing&objectid=3313&pageid=1',
                        src: require('../assets/geek-market-logo.svg'),
                        width: '100px',
                        height: '36px'
                    },
                    {
                        key: 'bonanza',
                        href: 'https://www.bonanza.com/items/search?q[search_term]=traverse%20board%20game',
                        src: require('../assets/bonanza-logo.svg'),
                        width: '100px',
                        height: '17px'
                    },
                    // {
                    //     key: 'educakorea',
                    //     href: 'https://www.educakorea.co.kr/new/product/detail.php?it_id=6956',
                    //     src: require('../assets/educakorea-logo.svg'),
                    //     width: '100px',
                    //     height: '17px'
                    // },
                ],
            }
        },
    };
</script>
